(function ($) {
    $(document).ready(function () {
        $('body .Search-result-card .search-pagination ul li a').click(function (e) {

            if ($('body .Search-result-card .search-pagination ul li a').hasClass("current")) {
                $('body .Search-result-card .search-pagination ul li a').removeClass("current");
            }
            $(this).addClass("current");
        })
    });
})(jQuery);